const MEDIA_ITEMS = [
  {
    tag: '编辑推荐',
    title: '2024年度漫画大赏获奖作品揭晓',
    desc: '本届大赏共评选出最佳少年漫、少女漫、青年漫等七大奖项，多部黑马作品入围引热议。',
    img: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20style%20manga%20illustration%20with%20trophy%20and%20celebration%20elements%2C%20warm%20coral%20and%20golden%20tones%2C%20festive%20atmosphere%2C%20clean%20minimal%20composition%2C%20elegant%20design%2C%20warm%20cream%20background%2C%20editorial%20style&width=560&height=360&seq=sakura-media-01&orientation=landscape',
    alt: '2024年度漫画大赏获奖作品揭晓，编辑推荐专题',
  },
  {
    tag: '新番速递',
    title: '七月新番追番指南：最值得期待的10部漫画',
    desc: '暑期档漫画盛宴来袭！热血、恋爱、悬疑应有尽有，这份追番清单帮你精准锁定目标。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20themed%20manga%20style%20illustration%20with%20colorful%20vibrant%20elements%2C%20multiple%20character%20silhouettes%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20festive%20summer%20atmosphere%2C%20clean%20composition%2C%20warm%20cream%20background&width=560&height=360&seq=sakura-media-02&orientation=landscape',
    alt: '七月新番追番指南，暑期最值得期待的漫画推荐',
  },
  {
    tag: '深度解读',
    title: '从分镜到叙事：解析漫画大师的创作密码',
    desc: '翻开经典漫画的每一页都是一堂课，带你了解那些令人叹为观止的分镜技巧与叙事手法。',
    img: 'https://readdy.ai/api/search-image?query=Manga%20storyboard%20and%20panel%20layout%20illustration%20showing%20creative%20process%2C%20dynamic%20page%20composition%20with%20sketch%20lines%2C%20warm%20sepia%20and%20coral%20tones%2C%20artistic%20workshop%20atmosphere%2C%20clean%20cream%20background&width=560&height=360&seq=sakura-media-03&orientation=landscape',
    alt: '漫画大师创作密码深度解读，从分镜到叙事的艺术',
  },
  {
    tag: '读者互动',
    title: '票选你最想动画化的漫画作品Top20',
    desc: '万人投票结果出炉！快来看看你心爱的漫画有没有上榜，一起期待这些作品早日动画化。',
    img: 'https://readdy.ai/api/search-image?query=Voting%20and%20ranking%20style%20manga%20illustration%20with%20numbered%20podiums%20and%20star%20ratings%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20community%20engagement%20theme%2C%20clean%20warm%20cream%20background%2C%20editorial%20layout&width=560&height=360&seq=sakura-media-04&orientation=landscape',
    alt: '票选最想动画化的漫画作品Top20，读者互动专题',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            漫画编辑团队为你精心挑选的优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium rounded-full bg-background-50/90 text-foreground-700">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}